module.exports = __webpack_public_path__ + "img/appdown.9b4040b5.svg";